import {
  createSelector,
  createStructuredSelector,
  defaultMemoize,
} from 'reselect';
import { flow, get, constant, split, last } from 'lodash/fp';

import { formFromQuery, parseAdsSearch } from 'components/searchAds';
import { selectCarMakeValues } from 'store/ducks/manufacturers';
import { getBreadcrumbsMetaFromCms } from 'helpers/cms';
import { getManualSeoSearchUrl } from 'helpers/namedUrls';

import { STORE_KEY, CMS_KEY } from '../../duck';
import { getCmsResult } from '../../selectors';

const getProps = (state, props) => props;

const getQueryFromLocation = createSelector(
  flow(getProps, get(['location', 'search'])),
  parseAdsSearch,
);

const getQueryFromCms = createSelector(
  getCmsResult,
  flow(get(['query']), split('?'), last, parseAdsSearch),
);

const getInitialForm = createSelector(
  getQueryFromCms,
  getQueryFromLocation,
  selectCarMakeValues,
  (queryFromCms, queryFromLocation, carMakeValues) =>
    formFromQuery(carMakeValues)({
      ...queryFromCms,
      ...queryFromLocation,
    }),
);

const getBreadcrumbs = defaultMemoize(
  getBreadcrumbsMetaFromCms([STORE_KEY, CMS_KEY], ({ link, ...rest }) => ({
    href: getManualSeoSearchUrl(link),
    ...rest,
  })),
);

const getBreadcrumbsHtml = createSelector(getCmsResult, get(['breadcrumbs']));

export default createStructuredSelector({
  breadcrumbs: getBreadcrumbs,
  breadcrumbsHtml: getBreadcrumbsHtml,
  cms: getCmsResult,
  initialForm: getInitialForm,
  userSearchType: constant('seo'),
  withExtraFilters: constant(true),
  withInitialAdResultsAmount: constant(false),
  withPromoBanner: constant(true),
  withWelcomeBanner: constant(false),
});
